export function handleGoBackRedirection(navigate, currentPath) {
  if (window.history.length > 1) {
    if (['/new/add', '/my-creations', '/news/add'].includes(currentPath)) {
      navigate('/profile');
    } else if (['/creations/add'].includes(currentPath)) {
      navigate('/my-creations');
    } else if (
      currentPath &&
      (currentPath.includes('/creation-detail') || currentPath.startsWith('/creations/'))
    ) {
      // Go back only when there is in-app history; otherwise use a safe fallback route.
      if (window.history.state?.idx > 0) {
        navigate(-1);
      } else {
        navigate('/explore');
      }
    } else if (currentPath && currentPath.startsWith('/news/')) {
      navigate('/news');
    } else if (!currentPath) {
      navigate('/explore');
    } else {
      navigate(-1);
    }
  } else {
    navigate('/');
  }
}
